// Kept apart from src/lib/PortalAccess.ts, whose permission checks load the shared Zod schemas: the
// portal and docs topbar needs only this, and signed-out docs pages shouldn't download those.
import type { ProjectTeam } from "shared/ProjectAccess";
import { ENABLE_APPEALS, ENABLE_HUMAN_REVIEW } from "shared/SharedConstants";

/** The locked-down portal for members who only work the human review queue. */
export const isReviewerPortal = (team: Pick<ProjectTeam, "role"> | undefined): boolean =>
  (ENABLE_HUMAN_REVIEW || ENABLE_APPEALS) && team?.role === "reviewer";
